// 图片懒加载
import Vue from 'vue'
import lazyload from "vue-lazyload"

Vue.use(lazyload)
